/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const es_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const de_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const nl_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const fr_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const it_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const pt_br2_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const pt_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const ja_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

const zh_scatter_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y
1,2.1
2,3.9
3,3.2`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_placeholder", locale)
	if (locale === "en") return en_scatter_placeholder(inputs)
	if (locale === "es") return es_scatter_placeholder(inputs)
	if (locale === "de") return de_scatter_placeholder(inputs)
	if (locale === "nl") return nl_scatter_placeholder(inputs)
	if (locale === "fr") return fr_scatter_placeholder(inputs)
	if (locale === "it") return it_scatter_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_placeholder(inputs)
	if (locale === "pt") return pt_scatter_placeholder(inputs)
	if (locale === "ja") return ja_scatter_placeholder(inputs)
	return zh_scatter_placeholder(inputs)
};